import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

import { RaterQuoteSaveButton } from '../footer/rater.quote.save.button';

interface IRaterQuoteSaveDialogProps {
  title: string;
  content: string;
  show: boolean;
  onConfirm: () => void;
  onCancel?: () => void;
}

export const RaterQuoteSaveDialog = (props: IRaterQuoteSaveDialogProps) => {
  return (
    <Dialog
      open={props.show}
      id="quote-save-dialog"
      onClose={props.onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {props.content}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 2 }}>
        <RaterQuoteSaveButton onComplete={props.onConfirm} />
        <Button onClick={props.onCancel} variant="contained" autoFocus>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
